<ng-container >
  <div class="container">
    <div class="box">
      <div class="row">
        <h5>Selecione a sua modalidade</h5>
      </div>
      <div class="row">
        <div class="col-md-6" *ngFor="let modalidade of modalidades">
          <a href="javascript:void(0)" (click)="escolhaModalidade(modalidade.sigla)">
            <div class="card text-center bg-light mb-2">
              <div class="card-body">
                <p class="card-text"> {{modalidade.nome}}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</ng-container>



